import { styled } from '@linaria/react';
import { fonts, semantic, size, space } from '../../theme/tokens';
import { EntityImage } from '../../components/EntityImage';

export const Panel = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space['space-300']};
`;

export const OptionsSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space['space-300']};
`;

export const SelectionCount = styled.span`
  font-family: ${fonts.body};
  font-size: ${fonts.size.sm};
  font-weight: ${fonts.weight.normal};
  color: ${semantic.text.secondary};
`;

export const OptionCard = styled.button`
  display: flex;
  align-items: center;
  gap: ${space['space-500']};
  width: 100%;
  padding: ${space['space-500']};
  border: ${size.stroke['stroke-default']} solid ${semantic.border.default};
  border-radius: ${size.radius['radius-lg']};
  background: ${semantic.bg.canvas};
  cursor: pointer;
  font-family: ${fonts.body};
  text-align: left;
  transition: border-color 0.15s ease, box-shadow 0.15s ease, opacity 0.15s ease;
  min-height: 72px;

  &:hover {
    border-color: ${semantic.text.secondary};
  }

  &[data-selected='true'] {
    border-width: ${size.stroke['stroke-thick']};
    border-color: ${semantic.border.selected};
    padding: calc(${space['space-500']} - 1px);
  }

  &[data-disabled='true'] {
    cursor: not-allowed;
    opacity: 0.5;
  }

  &[data-disabled='true']:hover {
    border-color: ${semantic.border.default};
  }
`;

export const OptionLabel = styled.span`
  font-family: ${fonts.body};
  font-size: ${fonts.size.base};
  font-weight: ${fonts.weight.normal};
  color: ${semantic.text.primary};
  flex: 1;
  min-width: 0;
`;

export const OptionImage = styled(EntityImage)`
  width: 80px;
  height: 80px;
  object-fit: cover;
  border-radius: ${size.radius['radius-xs']};
  flex-shrink: 0;
`;

export const OptionImagePlaceholder = styled.div`
  width: 80px;
  height: 80px;
  border-radius: ${size.radius['radius-xs']};
  flex-shrink: 0;
  background: ${semantic.bg.surfaceSubtle};
`;

export const TimeslotPanel = styled.div`
  background: ${semantic.bg.surfaceSubtle};
  border-radius: ${size.radius['radius-xl']};
  padding: ${space['space-800']};
  display: flex;
  flex-direction: column;
  gap: ${space['space-500']};
`;

export const TimeslotHeading = styled.span`
  font-family: ${fonts.body};
  font-size: ${fonts.size.base};
  font-weight: ${fonts.weight.normal};
  color: ${semantic.text.primary};
`;

export const SectionError = styled.div``;

export const TimeslotError = styled.div``;
